import { encryptPayload, decryptResponse } from "../utils/apiEnvelope";
import { getNewAuthToken, isTokenExpired } from "../utils";
import { baseURL } from "../utils/url";
import { encrypt } from "../utils/encodingdecoding";
import { CLEAR_CAMPAIGNS, CREATE_SAMPLE_CAMPAIGNS, GET_CAMPAIGNS, GET_SAMPLE_CAMPAIGNS, UPDATE_SAMPLE_CAMPAIGN, GET_CAMPAIGN } from "./type";

export const getCampaigns = (token, id) => async (dispatch) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + "campaigns?id=" + id, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        decryptResponse(fetchResponse)
            .then((res) => {
                if (res.length > 0) {
                    dispatch({
                        type: GET_CAMPAIGNS,
                        payload: res,
                    });

                    return res;
                } else {
                    dispatch({
                        type: GET_CAMPAIGNS,
                        payload: "no_cmp",
                    });
                }
            })
            .catch(() => {
                return null;
            });
    } catch (error) {
        return error;
    }
};

export const getCampaign = (token, id) => async (dispatch) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + "campaign?id=" + encrypt(id), {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return decryptResponse(fetchResponse)
            .then((res) => {
                
                let campaign = res?.data ?? res;
                if (Array.isArray(campaign)) campaign = campaign[0];
                const hasErrors = Array.isArray(res?.errors) ? res.errors.length > 0 : !!res?.errors;
                if (!hasErrors && campaign && typeof campaign === "object") {
                    dispatch({
                        type: GET_CAMPAIGN,
                        payload: campaign,
                    });
                    return campaign;
                }
                return null;
            })
            .catch(() => {
                return null;
            });
    } catch (error) {
        return error;
    }
};

export const getSampleCampaigns = (token, id, industry) => async (dispatch) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + "getsamplecampaigns?id=" + id + "&industry=" + industry, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        decryptResponse(fetchResponse)
            .then((res) => {
                if (res.length >= 0) {
                    dispatch({
                        type: GET_SAMPLE_CAMPAIGNS,
                        payload: res,
                        show: false,
                    });
                    return res;
                } else {
                    return null;
                }
            })
            .catch(() => {
                return null;
            });
    } catch (error) {
        return error;
    }
};

export const createsample = (token, data) => async (dispatch) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + "campaigns", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: encryptPayload(data),
        });
        decryptResponse(fetchResponse)
            .then((res) => {
                if (res.errors == null) {
                    dispatch({
                        type: CREATE_SAMPLE_CAMPAIGNS,
                        payload: res,
                    });

                    return res;
                } else {
                    return null;
                }
            })
            .catch(() => {
                return null;
            });
    } catch (error) {
        return error;
    }
};

export const getUserJourneyCampaigns = (token, data) => async (dispatch) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + "sampleCampaign", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: encryptPayload(data),
        });
        decryptResponse(fetchResponse)
            .then((res) => {
                if (res.length >= 0) {
                    dispatch({
                        type: GET_CAMPAIGNS,
                        payload: res,
                    });
                    return res;
                } else {
                    return null;
                }
            })
            .catch(() => {
                return null;
            });
    } catch (error) {
        return error;
    }
};

export const getEmailTemplatePlaceholder = async (token) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + "getEmailTemplatePlaceholder", {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await decryptResponse(fetchResponse);
    } catch (error) {
        return error;
    }
};

export const getCustomerGroupList = async (token) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + "getCustomerGroupList", {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await decryptResponse(fetchResponse);
    } catch (error) {
        return error;
    }
};
export const getCustomerGroupById = async (token, id) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + "getCustomerGroupId?id=" + encrypt(id), {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await decryptResponse(fetchResponse);
    } catch (error) {
        return error;
    }
};

export const getSponserById = async (token, id) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + "getSponserByid?id=" + id, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await decryptResponse(fetchResponse);
    } catch (error) {
        return error;
    }
};

export const getEmailTemplate = async (token) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + "getEmailTemplate", {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await decryptResponse(fetchResponse);
    } catch (error) {
        return error;
    }
};
export const postCombineCommunicationFlow = async (token, body) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + "postCombineCommunicationFlow", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: encryptPayload(body),
        });
        return await decryptResponse(fetchResponse);
    } catch (error) {
        return error;
    }
};

export const getCommunicationFlowsList = async (token, campaignCode) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + "getCombineCommunicationFlowsList?campaignCode=" + encrypt(campaignCode), {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await decryptResponse(fetchResponse);
    } catch (error) {
        return error;
    }
};

export const updateCommunicationFlow = async (token, body, id) => {
    const valid = await isTokenExpired(token);
    try {
        if (!valid)
            await getNewAuthToken().then((res) => {
                localStorage.setItem("token_gen", JSON.stringify(res));
                token = res?.access_token;
            });
        const fetchResponse = await fetch(baseURL + `putCombineCommunicationFlow?id=${id}`, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: encryptPayload(body),
        });
        return await decryptResponse(fetchResponse);
    } catch (error) {
        return error;
    }
};

export const updateSampleCampaign = (data) => (dispatch) => {
    dispatch({ type: UPDATE_SAMPLE_CAMPAIGN, payload: data });
};

export const clearCampaigns = () => async (dispatch) => {
    dispatch({ type: CLEAR_CAMPAIGNS });
};
